'use client'

import PageWrapper from 'components/PageWrapper'
import BlogPage from 'components/BlogPage'
import type { BlogListSectionProps } from 'components/BlogPage/BlogListSection'
import PAGE_CONSTANT_TEXTS from 'constants/pageMetaTags'
import BreadcrumbList from 'components/StructuredData'

function Blog(props: BlogListSectionProps) {
  return (
    <PageWrapper {...PAGE_CONSTANT_TEXTS.blogListing}>
      <BreadcrumbList nameH1="Mobile Development Services" />
      <BlogPage {...props} />
    </PageWrapper>
  )
}

export default Blog
